import { MvccDataService } from "martti-agent-services"
import { logger } from "./logger"
import { config } from "./configService"
import { authService as auth } from "./authService"

const dataServiceInstance = new MvccDataService({ logger, config, auth })

export const dataService = dataServiceInstance
